import { render, staticRenderFns } from "./FieldCollection.vue?vue&type=template&id=5aa8f350&scoped=true&"
import script from "./FieldCollection.vue?vue&type=script&lang=js&"
export * from "./FieldCollection.vue?vue&type=script&lang=js&"
import style0 from "./FieldCollection.vue?vue&type=style&index=0&id=5aa8f350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa8f350",
  null
  
)

export default component.exports